import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet, useRouterState } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { Sidebar } from './components/Sidebar';
import { Header } from './components/Header';
import { NotificationsProvider } from '@/providers/NotificationsProvider';
import { useOppositionSync } from '@/shared/hooks/useOppositionSync';
export function AppLayout() {
    useOppositionSync();
    const [mobileOpen, setMobileOpen] = useState(false);
    const pathname = useRouterState({ select: (s) => s.location.pathname });
    // Cerrar el drawer móvil al navegar a otra ruta
    useEffect(() => {
        setMobileOpen(false);
    }, [pathname]);
    // Bloquear el scroll del body mientras el drawer móvil está abierto
    useEffect(() => {
        document.body.style.overflow = mobileOpen ? 'hidden' : '';
        return () => {
            document.body.style.overflow = '';
        };
    }, [mobileOpen]);
    return (
    // Mounted only once the user is on an authenticated route (tokens present),
    // so the notification queries (enabled: isAuthenticated()) fire right after
    // login instead of staying disabled until a full page refresh.
    _jsx(NotificationsProvider, { children: _jsxs("div", { className: "flex h-screen overflow-hidden", style: { background: 'var(--bg)', color: 'var(--fg)' }, children: [_jsx(Sidebar, { mobileOpen: mobileOpen, onClose: () => setMobileOpen(false) }), mobileOpen && (_jsx("div", { className: "fixed inset-0 z-30 bg-black/50 md:hidden", onClick: () => setMobileOpen(false), "aria-hidden": "true" })), _jsxs("div", { className: "flex flex-1 flex-col overflow-hidden", children: [_jsx(Header, { onMenuClick: () => setMobileOpen(true) }), _jsx("main", { className: "flex-1 overflow-y-auto p-4 sm:p-6", children: _jsx(Outlet, {}) })] })] }) }));
}
//# sourceMappingURL=AppLayout.js.map